import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fc3f9be"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "vietnam-island-star",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12 2.5l2.85 5.77 6.37.93-4.61 4.49 1.09 6.34L12 17.03l-5.7 3 1.09-6.34L2.78 9.2l6.37-.93L12 2.5z",
    fill: "#FFD21F",
    stroke: "#D71920",
    "stroke-width": "1.7",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_3 = { class: "vietnam-island-label" }

import { computed } from 'vue';
import type { VietnamIslandMarkerDef } from '@/components/dashboard/map/constants/vietnam-island-markers';
import type { VietnamIslandScreenPosition } from '@/components/dashboard/map/composables/useVietnamIslandMarkers';


export default /*#__PURE__*/_defineComponent({
  __name: 'VietnamIslandMarker',
  props: {
    marker: {},
    position: {}
  },
  setup(__props: any) {

const props = __props;

const style = computed(() => ({
  left: `${props.position.x}px`,
  top: `${props.position.y}px`,
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "vietnam-island-marker",
    style: _normalizeStyle(style.value),
    "aria-label": _ctx.marker.displayName,
    role: "img",
    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop","prevent"]))
  }, [
    _hoisted_2,
    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.marker.displayName), 1)
  ], 12, _hoisted_1))
}
}

})